'use client';

import { useSession } from '@shared/auth';
import { buildPlayerTrackerImpressionPayload, usePlayerTrackerServiceEvent } from '@shared/tracking';
import { useEffect, useRef } from 'react';
import { getPaymentLimitImpressionName } from '../utils/getPaymentLimitImpressionName';

/**
 * Fires a VGCCC payment-limit PTS impression once when the matching Aurum error is shown.
 * No-ops when the error key is unrelated or the market has not enabled the impression.
 */
function usePaymentLimitImpressionTracking(errorKey?: string | null) {
  const impressionName = getPaymentLimitImpressionName(errorKey);
  const ptsTrackEvent = usePlayerTrackerServiceEvent();
  const { session } = useSession();
  const hasTrackedImpressionRef = useRef(false);

  useEffect(() => {
    if (!impressionName || hasTrackedImpressionRef.current) return;

    const payload = buildPlayerTrackerImpressionPayload(impressionName, session.profile);
    if (!payload) return;

    hasTrackedImpressionRef.current = true;
    ptsTrackEvent(payload);
  }, [impressionName, ptsTrackEvent, session.profile]);

  return impressionName;
}

export { usePaymentLimitImpressionTracking };
